export default __webpack_public_path__ + "static/media/xiaomiredmi14.026d4b09.png";